var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.77454,
    cy: 23.5,
    r: 5,
    fill: "white",
    stroke: "#1D2B36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6471 0C3.43058 0 2.39313e-05 3.58889 2.39313e-05 8.00002C2.39313e-05 9.32423 0.316496 10.6372 0.918119 11.8018L7.22891 23.7422C7.31293 23.9014 7.47302 24 7.6471 24C7.82117 24 7.98127 23.9014 8.06528 23.7422L14.3784 11.7978C14.9777 10.6372 15.2942 9.32419 15.2942 7.99997C15.2942 3.58889 11.8636 0 7.6471 0ZM7.6471 12C5.53884 12 3.82358 10.2056 3.82358 8.00002C3.82358 5.79445 5.53884 4.00003 7.6471 4.00003C9.75536 4.00003 11.4706 5.79445 11.4706 8.00002C11.4706 10.2056 9.75536 12 7.6471 12Z",
    fill: "#1D2B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.84568f8f2a061d2d8c4c23d3aab93fdd.svg";
export { ForwardRef as ReactComponent };